
import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {

    let type;

    function initSwiper() {
        if (!type) {
            type = new Swiper('.type-product__flex', {
                modules: [Navigation, Pagination],
                loop: true,
                slidesPerView: 5,
                spaceBetween: 8,
                navigation: {
                    nextEl: '.type-product__nav-right',
                    prevEl: '.type-product__nav-left',
                },
                breakpoints : {
                    320 : {
                        slidesPerView: 1,
                        spaceBetween: 8,
                    },
                    768 : {
                        slidesPerView: 3,
                        spaceBetween: 8,
                    },
                    992 : {
                        slidesPerView: 3,
                        spaceBetween: 8,
                    },
                    1300 : {
                        slidesPerView: 4,
                        spaceBetween: 8,
                    },
                }
            });
        }
    }

    initSwiper();

});